import React from 'react';

export function L({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <div className="mb-1 text-xs font-medium text-gray-700">{label}</div>
      {children}
    </label>
  );
}
